import React from "react";
import PropTypes from "prop-types";
import "./Logo.scss";
import { ICONPATH } from "../../Constant";

export const Logo = ({ ...props }) => {
  return (
    <div className="es-custom-default-logo" style={{ marginTop: "10px" }}>
      <img className="img" src={ICONPATH.Logo} alt="logo" />
    </div>
  );
};

Logo.propTypes = {};

Logo.defaultProps = {};
